import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=3f7af436&scoped=true"
import script from "./CardList.vue?vue&type=script&lang=js"
export * from "./CardList.vue?vue&type=script&lang=js"
import style0 from "./CardList.vue?vue&type=style&index=0&id=3f7af436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7af436",
  null
  
)

export default component.exports